module.exports = __webpack_public_path__ + "static/media/pra-picture-barrer.00ae5fdb.png";